<template>
  <v-container fluid class="pa-0 bg-slate-50 min-h-screen" style="font-family: 'Inter', sans-serif;">
    <div class="p-6">
    <div class="max-w-5xl mx-auto">
      
      <!-- HEADER -->
      <div class="mb-6 flex items-center justify-between">
        <div>
          <button @click="$router.back()" class="flex items-center gap-2 text-slate-400 hover:text-orange-600 transition-colors mb-2">
            <v-icon small color="inherit">mdi-arrow-left</v-icon>
            <span class="text-[10px] font-bold uppercase tracking-wider">Voltar</span>
          </button>
          <h1 class="text-2xl font-bold text-slate-700">{{ id ? 'Editar Motorista' : 'Cadastrar Motorista' }}</h1>
        </div>
      </div>

      <div class="space-y-6 pb-12">
        <!-- CARD 1: DADOS PESSOAIS E FOTO -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>mdi-account-details</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">DADOS PESSOAIS E FOTO</h2>
          </div>
          
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
              <!-- Foto e Nome/Código -->
              <div class="md:col-span-3 flex flex-col items-center gap-3 border-r border-slate-100 pr-6">
                 <div class="relative group cursor-pointer" @click="$refs.fileInput.click()">
                    <div class="w-32 h-32 rounded-2xl overflow-hidden border-2 border-slate-100 group-hover:border-orange-400 transition-colors bg-slate-50">
                      <img :src="data.driver_photo ? $store.state.urlImages + data.driver_photo : require('@/assets/no-image.jpg')" 
                           class="w-full h-full object-cover" />
                    </div>
                    <div class="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl">
                       <v-icon color="white">mdi-camera-plus</v-icon>
                    </div>
                 </div>
                 <input type="file" accept="image/jpeg, image/png" @change="uploadImage" ref="fileInput" class="hidden" />
                 <p class="text-[9px] font-bold text-slate-400 uppercase text-center tracking-tighter">Clique para alterar a foto</p>
              </div>

              <div class="md:col-span-9">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
                  <!-- Código -->
                  <div class="md:col-span-3">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Código</label>
                    <input type="text" v-model="data.driver_cod" placeholder="000"
                      class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                  </div>

                  <!-- Nome -->
                  <div class="md:col-span-9">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Nome Completo</label>
                    <input type="text" v-model="data.driver_name" placeholder="NOME DO MOTORISTA"
                      class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                  </div>

                  <!-- Prefeitura -->
                  <div class="md:col-span-12">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Prefeitura</label>
                    <select v-model="data.prefecture_id" :disabled="userGroup != 1"
                      class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                      <option :value="null" disabled>SELECIONE A PREFEITURA...</option>
                      <option v-for="item in prefectures" :key="item.prefecture_id" :value="item.prefecture_id">
                        {{ item.prefecture_social_name }}
                      </option>
                    </select>
                  </div>

                  <!-- Sexo -->
                  <div class="md:col-span-4">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Sexo</label>
                    <select v-model="data.driver_genre" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                      <option value="">SELECIONE...</option>
                      <option value="Masculino">Masculino</option>
                      <option value="Feminino">Feminino</option>
                      <option value="Outros">Outros</option>
                    </select>
                  </div>

                  <!-- Data Nascimento -->
                  <div class="md:col-span-4">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Data Nascimento</label>
                    <input type="text" v-mask-date.br v-model="data.driver_birth" placeholder="DD/MM/AAAA"
                      class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  </div>

                  <!-- Estado Civil -->
                  <div class="md:col-span-4">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Estado Civil</label>
                    <select v-model="data.driver_marital_status" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                      <option value="">SELECIONE...</option>
                      <option v-for="item in ['Casado', 'Solteiro', 'Viúvo', 'União Estável']" :key="item" :value="item">{{ item }}</option>
                    </select>
                  </div>

                  <!-- Nível de Formação -->
                  <div class="md:col-span-12">
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Nível de Formação</label>
                    <select v-model="data.driver_education_level" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                      <option value="">SELECIONE...</option>
                      <option v-for="item in ['Fundamental Incompleto', 'Fundamental Completo', 'Ensino Médio Incompleto', 'Ensino Médio Completo', 'Ensino Superior Incompleto', 'Ensino Superior Completo', 'Mestrado', 'Doutorado', 'Pós-Doutorado']" :key="item" :value="item">{{ item }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- CARD 2: DOCUMENTAÇÃO E CNH -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>mdi-card-account-details-outline</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">DOCUMENTAÇÃO E CNH</h2>
          </div>
          
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
              <!-- CPF -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">CPF</label>
                <input type="text" v-mask-cpf v-model="data.driver_cpf" placeholder="000.000.000-00"
                  :class="['w-full bg-slate-50 border rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:ring-1 transition-colors', 
                           data.driver_cpf !== '' && !validCpf(data.driver_cpf) ? 'border-red-300 ring-red-300' : 'border-slate-200 focus:border-orange-500 focus:ring-orange-500']">
                <span v-if="data.driver_cpf !== '' && !validCpf(data.driver_cpf)" class="text-[9px] text-red-500 font-bold uppercase mt-1 ml-1">CPF Inválido</span>
              </div>

              <!-- Identidade -->
              <div class="md:col-span-8">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Identidade / Órgão Emissor / UF</label>
                <input type="text" v-model="data.driver_identidade" placeholder="EX: 00.000.000-0 SSP/PB"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- CNH Registro -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Nº Registro (CNH)</label>
                <input type="text" v-model="data.driver_cnh_registro" placeholder="00000000000"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- CNH Categoria -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Categoria (CNH)</label>
                <select v-model="data.driver_category" class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                  <option value="">SELECIONE...</option>
                  <option v-for="item in ['A', 'B', 'C', 'D', 'E', 'AB', 'AC', 'AD', 'AE']" :key="item" :value="item">{{ item }}</option>
                </select>
              </div>

              <!-- 1ª Habilitação -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">1º Habilitação (CNH)</label>
                <input type="text" v-mask-date.br v-model="data.driver_first_habilitation" placeholder="DD/MM/AAAA"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>

              <!-- Data Emissão -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Data Emissão (CNH)</label>
                <input type="text" v-mask-date.br v-model="data.driver_date_emission" placeholder="DD/MM/AAAA"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>

              <!-- Data Validade -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Data Validade (CNH)</label>
                <input type="text" v-mask-date.br v-model="data.driver_date_validity" placeholder="DD/MM/AAAA"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>
            </div>
          </div>
        </section>

        <!-- CARD 3: CONTATO E ENDEREÇO -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>mdi-map-marker-radius</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">CONTATO E ENDEREÇO</h2>
          </div>
          
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
              <!-- Email -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">E-mail</label>
                <input type="email" v-model="data.driver_mail" placeholder="EMAIL@EXEMPLO.COM"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- Celular -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Celular</label>
                <input type="text" v-mask-phone.br v-model="data.driver_cel" placeholder="(00) 00000-0000"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>

              <!-- Telefone -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Telefone</label>
                <input type="text" v-mask-phone.br v-model="data.driver_tel" placeholder="(00) 0000-0000"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
              </div>

              <!-- CEP -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">CEP</label>
                <div class="relative">
                  <input type="text" v-mask-cep v-model="data.driver_postal_code" placeholder="00.000-000"
                    @blur="getCep(data.driver_postal_code)"
                    class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors">
                  <div v-if="loader" class="absolute right-3 top-2.5">
                    <span class="animate-spin h-4 w-4 border-2 border-orange-500 border-t-transparent rounded-full block"></span>
                  </div>
                </div>
              </div>

              <!-- Logradouro -->
              <div class="md:col-span-7">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Logradouro (Rua/Av)</label>
                <input type="text" v-model="data.driver_street" placeholder="EX: RUA DAS FLORES"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- Número -->
              <div class="md:col-span-2">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Número</label>
                <input type="text" v-model="data.driver_number" placeholder="S/N"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- Complemento -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Complemento</label>
                <input type="text" v-model="data.driver_complement" placeholder="EX: APTO 101"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- Bairro -->
              <div class="md:col-span-3">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Bairro</label>
                <input type="text" v-model="data.driver_district" placeholder="EX: CENTRO"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- Cidade -->
              <div class="md:col-span-4">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Cidade</label>
                <input type="text" v-model="data.driver_city" placeholder="EX: CURITIBA"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>

              <!-- Estado -->
              <div class="md:col-span-2">
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Estado (UF)</label>
                <input type="text" v-model="data.driver_state" placeholder="EX: PR"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
              </div>
            </div>
          </div>
        </section>

        <!-- CARD 4: CREDENCIAIS DE ACESSO -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>mdi-lock-outline</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">CREDENCIAIS DE ACESSO</h2>
          </div>
          
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Bloqueio de Abastecimento Independente -->
              <div class="md:col-span-2 border-b border-slate-100 pb-4 mb-2 flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <div :class="['p-2 rounded-lg', data.driver_independent_refuel_blocked ? 'bg-amber-50' : 'bg-slate-50']">
                    <v-icon :color="data.driver_independent_refuel_blocked ? 'orange' : 'slate-400'" small>
                      {{ data.driver_independent_refuel_blocked ? 'mdi-fuel-off' : 'mdi-fuel' }}
                    </v-icon>
                  </div>
                  <div>
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1">Bloqueio de abastecimento independente</label>
                    <p class="text-[9px] text-slate-400 uppercase font-bold ml-1 mb-0">
                      {{ data.driver_independent_refuel_blocked ? 'O motorista só abastece com autorizações liberadas para ele' : 'O motorista pode criar o próprio abastecimento normalmente' }}
                    </p>
                  </div>
                </div>
                <v-switch v-model="data.driver_independent_refuel_blocked" color="orange" inset dense class="mt-0" hide-details></v-switch>
              </div>

              <!-- Status de Acesso -->
              <div class="md:col-span-2 border-b border-slate-100 pb-4 mb-2 flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <div :class="['p-2 rounded-lg', data.driver_active ? 'bg-emerald-50' : 'bg-slate-50']">
                    <v-icon :color="data.driver_active ? 'success' : 'slate-400'" small>
                      {{ data.driver_active ? 'mdi-account-check' : 'mdi-account-off' }}
                    </v-icon>
                  </div>
                  <div>
                    <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1">Status de Acesso</label>
                    <p class="text-[9px] text-slate-400 uppercase font-bold ml-1 mb-0">
                      {{ data.driver_active ? 'O motorista possui acesso liberado ao sistema' : 'O acesso deste motorista está bloqueado' }}
                    </p>
                  </div>
                </div>
                <v-switch v-model="data.driver_active" color="orange" inset dense class="mt-0" hide-details></v-switch>
              </div>

              <!-- Login -->
              <div>
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Login</label>
                <input type="text" v-model="data.driver_login" placeholder="DEIXE EM BRANCO PARA GERAR AUTOMÁTICO"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                <p class="text-[9px] text-slate-400 mt-1 uppercase font-bold ml-1">Se deixado em branco, será gerado automaticamente.</p>
              </div>

              <!-- Senha -->
              <div>
                <label class="block text-[10px] font-bold uppercase text-slate-400 tracking-widest ml-1 mb-1">Senha</label>
                <input type="text" v-model="data.driver_password" placeholder="DEIXE EM BRANCO PARA GERAR AUTOMÁTICO"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase">
                <p class="text-[9px] text-slate-400 mt-1 uppercase font-bold ml-1">Se deixado em branco, será gerado automaticamente.</p>
              </div>
            </div>
          </div>

          <!-- FOOTER DENTRO DO CARD FINAL (PADRÃO DO SISTEMA) -->
          <div class="bg-slate-50 px-8 py-5 border-t border-slate-200 flex justify-end items-center gap-4">
            <button 
              @click="$router.back()" 
              class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
            >
              Cancelar
            </button>
            <div class="flex-none">
              <button 
                @click="validate" 
                :disabled="loader"
                class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
              >
                <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
                <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
              </button>
            </div>
          </div>
        </section>
      </div>

      <!-- NOTIFICAÇÕES -->
      <v-snackbar
        v-model="snack.show"
        :color="snack.color"
        timeout="3000"
        rounded="lg"
        elevation="24"
      >
        {{ snack.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snack.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      driver_cod: "",
      driver_id: null,
      driver_name: "",
      driver_photo: "",
      driver_cpf: "",
      driver_birth: "",
      driver_genre: "",
      driver_education_level: "",
      driver_marital_status: "",
      driver_mail: "",
      driver_cel: "",
      driver_tel: "",
      driver_postal_code: "",
      driver_street: "",
      driver_number: "",
      driver_complement: "",
      driver_district: "",
      driver_city: "",
      driver_state: "",
      driver_login: "",
      driver_password: "",
      driver_first_habilitation: "",
      driver_date_emission: "",
      driver_date_validity: "",
      driver_identidade: "",
      driver_cnh_registro: "",
      driver_category: "",
      prefecture_id: null,
      driver_active: true,
      driver_independent_refuel_blocked: false,
    },
    userGroup: null,
  }),
  created() {
    this.userGroup = this.$store.getters.getUserData.group_id;
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`drivers/${this.id}`).then((r) => {
        this.data = r.data[0];
        delete this.data.created_at;
        if (this.data.driver_independent_refuel_blocked === null || this.data.driver_independent_refuel_blocked === undefined) {
          this.data.driver_independent_refuel_blocked = false;
        }
        this.$store.dispatch("setLoader", false);
      });
    } else {
      this.data.prefecture_id = this.$store.getters.getUserData.table_id;
    }
  },
  methods: {
    validCpf(cpf) {
      if (!cpf) return false;
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    },
    validate() {
      if (!this.data.driver_name || !this.data.prefecture_id) {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atenção: Preencha os campos obrigatórios (Nome e Prefeitura)!";
        return;
      }

      // Validação de nome completo (pelo menos nome e sobrenome)
      const nameParts = this.data.driver_name.trim().split(/\s+/);
      if (nameParts.length < 2) {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atenção: Informe o nome completo (nome e sobrenome)!";
        return;
      }

      if (this.data.driver_cpf && !this.validCpf(this.data.driver_cpf)) {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "CPF inválido!";
        return;
      }

      this.createOrUpdate();
    },
    createOrUpdate() {
      this.loader = true;
      const method = this.id ? 'put' : 'post';
      const url = this.id ? `/drivers/${this.id}` : '/drivers';
      
      this.$store.dispatch("setLoader", this.loader);
      this.$http[method](url, this.data)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result || "Sucesso!";
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
          setTimeout(() => {
            this.$router.push("/drivers-manager");
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
    uploadImage(event) {
      if (!event.target.files.length) return;
      this.$store.dispatch("setLoader", true);
      const fd = new FormData();
      fd.append("image", event.target.files[0], event.target.files[0].name);
      this.$http
        .post("/upload", fd)
        .then((r) => {
          this.data.driver_photo = r.data.cover;
          this.$store.dispatch("setLoader", false);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = "Erro ao realizar upload da imagem. " + e.message;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
          event.target.files = [];
        });
    },
    getCep(cep) {
      if (!cep) return;
      if (cep.length >= 10) {
        this.loader = true;
        cep = cep.replace(/\D/g, "");
        this.$http
          .get("https://viacep.com.br/ws/" + cep + "/json/")
          .then((response) => {
            if (!response.data.erro) {
              this.data.driver_street = response.data.logradouro;
              this.data.driver_district = response.data.bairro;
              this.data.driver_city = response.data.localidade;
              this.data.driver_state = response.data.uf;
            } else {
              this.snack.show = true;
              this.snack.message = "CEP não encontrado!";
              this.snack.color = "warning";
            }
            this.loader = false;
          })
          .catch((e) => {
            console.error("Erro ao buscar CEP:", e);
            this.loader = false;
          });
      }
    },
  },
};
</script>

<style scoped>
/* Estilos específicos para Inter se necessário, embora já incluído inline */
</style>
